const recruitData = {
  jobsData: [
    {
      title: 'H5前端开发工程师',
      hide: false,
      unfold: false,
      salary: '10K-30K',
      basic: '深圳/2年以上/本科',
      jobDescription: {
        title: '工作职责',
        content: [
          '负责综合金融类 APP 的 web 端和 RN 端开发'
        ]
      },
      employRequirement: {
        title: '应聘要求',
        content: [
          '2年以上移动开发经验，本科以上学历',
          '扎实的 HTML + CSS + JavaScript 基础，熟练运用 ES6+',
          '掌握 React 或 Vue 前端开发框架',
          '有良好的代码风格、接口设计和架构能力',
          '有责任心，具备良好的团队协作能力和沟通能力',
          '有 Hybrid App / React Native 开发经验者优先'
        ]
      }
    },
    {
      title: 'iOS开发工程师',
      hide: false,
      unfold: false,
      salary: '10K-30K',
      basic: '深圳/2年以上/本科',
      jobDescription: {
        title: '工作职责',
        content: [
          '根据负责 iOS APP 的需求开发工作',
          '负责承担版本的架构设计、性能及调优工作',
          '规范文档的编写、维护，以及其他与项目相关的研发工作',
          'iOS 客户端技术和业务的探索性预研'
        ]
      },
      employRequirement: {
        title: '应聘要求',
        content: [
          '熟练使用 iOS 各种控件，界面修改，动画，多线程，网络通信等操作',
          '具有丰富的 iOS 开发经验和调试经验，有软件架构设计能力，能独立分析复杂代码并重构优化',
          '对 iOS 内存管理，内存泄露，内存异常处理有一定经验',
          '对数据结构、算法和设计模式有一定的理解',
          '具备良好的分析解决问题能力，能独立承担任务和有系统进度把控能力',
          '有良好的学习能力和强烈的进取心和创新意识',
          '热爱互联网保险优先',
          '有 RN、Weex 等跨平台经验优先。'
        ]
      }
    },
    {
      title: 'Android开发工程师',
      hide: false,
      unfold: false,
      salary: '10K-30K',
      basic: '深圳/2年以上/本科',
      jobDescription: {
        title: '工作职责',
        content: [
          '根据负责 Android APP 的需求开发工作',
          '负责承担版本的架构设计、性能及调优工作',
          '规范文档的编写、维护，以及其他与项目相关的研发工作',
          'Android客户端技术和业务的探索性预研'
        ]
      },
      employRequirement: {
        title: '应聘要求',
        content: [
          '熟练使用Android各种控件，界面修改，动画，多线程，网络通信等操作',
          '具有丰富的Android开发经验和调试经验，有软件架构设计能力，能独立分析复杂代码并重构优化',
          '对Android内存管理，内存泄露，内存异常处理有一定经验',
          '熟悉java，对数据结构、算法和设计模式有一定的理解',
          '具备良好的分析解决问题能力，能独立承担任务和有系统进度把控能力',
          '有良好的学习能力和强烈的进取心和创新意识',
          '热爱互联网保险优先',
          '有RN、Weex等跨平台经验优先。'
        ]
      }
    },
    // {
    //   title: '测试开发工程师',
    //   hide: false,
    //   unfold: false,
    //   salary: '10K-30K',
    //   basic: '深圳/1年以上/本科',
    //   jobDescription: {
    //     title: '工作职责',
    //     content: [
    //       '参与团队质量体系规划与建设，推动团队的自动化测试与持续集成改进等工作',
    //       '负责团队内部的测试相关工具、框架与平台的功能开发及维护'
    //     ]
    //   },
    //   employRequirement: {
    //     title: '应聘要求',
    //     content: [
    //       '计算机相关专业，本科及以上学历，1年以上测试开发经验',
    //       '熟悉Linux/Unix，具备优秀的代码基础，熟练掌握Java/PHP/Python/Shell等至少一门语言',
    //       '在某一个技术领域上（如客户端专项、服务端性能）有深入研究，有自动化测试平台开发和应用经验者优先',
    //       '逻辑思维缜密，具备优秀的问题发现、问题分析与问题解决能力，有强烈的责任心和团队精神'
    //     ]
    //   }
    // },
    {
      title: '软件测试工程师',
      hide: false,
      unfold: false,
      salary: '10K-30K',
      basic: '深圳/3年以上/本科',
      jobDescription: {
        title: '工作职责',
        content: [
          '负责移动端、服务端产品的功能测试，性能测试，以及其他专项测试事务',
          '参与所负责产品线的全流程质量保障工作，包括参与需求分析，制定测试计划，设计测试方案，执行测试用例等',
          '分析测试结果，输出测试报告，推动测试过程改进及测试效率提升',
          '推动项目进度，保障产品质量'
        ]
      },
      employRequirement: {
        title: '应聘要求',
        content: [
          '大学本科及以上学历，3年以上APP或大型后台系统测试经验，有较强的测试执行能力和推动能力',
          '至少熟练掌握一门开发语言（object-c /Java），熟悉至少一种脚本语言 Python/Shell/Ruby等',
          '熟悉安卓/ios/linux系统特性，具备较好的数据库知识',
          '在某一测试领域上（如性能测试、兼容性测试、接口测试等）有较好的技术水准。熟练掌握Jmeter，postman，appium等测试工具',
          '有大型互联网公司经验者优先，有敏捷，持续集成经验者优先',
          '学习能力强，有良好的责任心和沟通能力，富有团队精神'
        ]
      }
    },
    {
      title: 'Java开发工程师',
      hide: false,
      unfold: false,
      salary: '10K-30K',
      basic: '深圳/3年以上/本科',
      jobDescription: {
        title: '工作职责',
        content: [
          '负责互联网产品服务端研发工作，对接产品需求，程序设计',
          '对系统进行持续优化、重构,引入新技术，提升研发效率,支持业务快速发展',
          '编写技术/设计文档',
          '缺陷修复及生产问题诊断'
        ]
      },
      employRequirement: {
        title: '应聘要求',
        content: [
          '本科及以上学历，计算机及相关专业',
          '互联网相关行业2年及以上相关工作经验',
          '熟练掌握主流开发框架和技术，如spring、mybatis、angularjs、kafka、zookeeper、dubbo、memcache、redis、springBoot、springCloud、Netty等',
          '熟悉设计模式，熟悉多线程及并发设计，熟悉Oracle、mysql数据库',
          '有较强的主动学习能力、逻辑思维能力、分析并解决问题的能力',
          '较强的责任心及团队合作精神，有独立解决问题和快速学习并应用新技术的能力'
        ]
      }
    },
    {
      title: '运维工程师',
      hide: false,
      unfold: false,
      salary: '10K-30K',
      basic: '深圳/2年以上/本科',
      jobDescription: {
        title: '工作职责',
        content: [
          '管理和维护公司各系列应用系统，通过实施问题主动预防措施以及对故障的快速恢复确保各应用系统的可用性，支持业务发展',
          '根据监控方法论实施应用监控，进行系统日常健康检查，确保异常能够被及时发现并处理',
          '日常变更风险评估应对及变更后验证，消除变更风险对业务影响',
          '进行系统容量管理，确保系统容量适合正常业务开展的需要',
          '研究监控方法，开发维护监控工具'
        ]
      },
      employRequirement: {
        title: '应聘要求',
        content: [
          '计算机相关专业本科（含）以上学历，2年以上IT运维经历',
          '熟悉WEBLOGIC、TOMCAT、J2EE等技术知识',
          '熟悉Oracle、Mysql、PostgreSQL、redis等数据库中的2种以上数据库的运维管理和调优',
          '了解linux操作系统原理，包括进程、网络、IO等；熟悉linux操作命令，熟练掌握shell、awk、Python脚本语言',
          '有openstack、docker、lvs、nginx、kafka、MQ、storm、flink等相关运维经验者优先',
          '有微服务应用维护经验者优先',
          '具备较强的问题分析能力和解决能力；具备良好的学习能力、沟通协调能力、团队协作能力，有高度的工作责任心、抗压能力强'
        ]
      }
    },
    {
      title: '数据库管理员（DBA）',
      hide: false,
      unfold: false,
      salary: '10K-30K',
      basic: '深圳/3年以上/本科',
      jobDescription: {
        title: '工作职责',
        content: [
          '负责生产数据库日常运维操作,确保数据库高效稳定运行，包括配置管理、升级、扩容、备份、数据迁移、灾难恢复和管理等工作',
          '负责数据库集群监控、故障响应、问题跟踪及性能分析处理',
          '制定数据库设计和开发规范，并定期对为公司内部研发、运营人员提供必要的技术和方案咨询，以及相关培训',
          '根据业务需求，改进数据库架构，实施数据库集群与负载均衡方案',
          '负责深入研究TIDB，持续推进在业务场景中的应用',
          '其他DBA日常工作事项'
        ]
      },
      employRequirement: {
        title: '应聘要求',
        content: [
          '本科及以上学历',
          '3年以上DBA相关工作经验（MySQL、Oracle、PostgreSQL 等），有TIDB运维实践经验优先',
          '精通一种关系型数据库的（如MySQL等）配置、备份、优化、监控、管理',
          '熟悉 Linux 操作系统，如常用命令、文件系统、系统配置等，具有较强的故障定位和问题解决能力，有丰富处理重大故障的经历',
          '熟悉 shell、python、perl 等脚本语言，对 Ansible、Docker、Prometheus 等技术领域有一定使用经验',
          '对分布式系统、ES、go熟悉者优先考虑',
          '高度的责任心、良好的抗压能力、沟通技巧和团队合作精神'
        ]
      }
    },
    // {
    //   title: 'UI视觉设计师',
    //   hide: false,
    //   unfold: false,
    //   salary: '10K-30K',
    //   basic: '深圳/3年以上/本科',
    //   jobDescription: {
    //     title: '工作职责',
    //     content: [
    //       '优秀的审美和视觉表达能力',
    //       '负责平安寿险产品与新功能提供创意策划并提供用户界面的设计方案',
    //       '负责为日常的寿险运营及功能维护提供设计支持；参与前瞻性产品的创意设计和动态DEMO的实现。'
    //     ]
    //   },
    //   employRequirement: {
    //     title: '应聘要求',
    //     content: [
    //       '3年以上相关工作经验，本科以上学历，有互联网移动端产品设计经验优先',
    //       '熟悉Photoshop、AE、Illustrator 等流行设计软件',
    //       '热爱视觉设计，时刻关注与把握设计趋势；了解交互设计',
    //       '熟悉平台应用界面控件视觉样式、动画、尺寸等细节特性',
    //       '具备整体画面控制力，并有对像素级细节严谨把控的专业精神。'

    //     ]
    //   },
    //   tips: '注：简历发送时带个人作品。'
    // },
    // {
    //   title: '交互设计师',
    //   hide: false,
    //   unfold: false,
    //   salary: '10K-30K',
    //   basic: '深圳/3年以上/本科',
    //   jobDescription: {
    //     title: '工作职责',
    //     content: [
    //       '优秀的审美和表达能力',
    //       '负责平安寿险产品，PC与Mobile页面的交互设计和实现',
    //       '参与需求的讨论制定，确立设计目标',
    //       '参与用户体验设计，给出有效的交互解决方案，并推动方案的落地',
    //       '参与文案的撰写与把控，使内容通俗、清晰、流畅，并更有吸引力',
    //       '参与用户研究，根据结论对产品进行优化',
    //       '梳理产品设计规范，推动规范在团队执行，让体验更一致，迭代更高效。'
    //     ]
    //   },
    //   employRequirement: {
    //     title: '应聘要求',
    //     content: [
    //       '本科或以上学历，人机交互、视觉传达、工业设计或相关设计专业毕业',
    //       '3年以上互联网产品设计及相关工作经验',
    //       '熟悉交互设计相关理论、工具及方法，并对信息架构、访问路径、页面布局等设计流程有深入理解',
    //       '熟练掌握设计产出的各类技能，包括流程及线框图，低保真原型等内容的输出；（软件不限）',
    //       '善于并乐于了解互联网新事物，对业界流行的设计元素有深入的见解',
    //       '熟悉互联网产品设计、开发和运营流程，有良好的团队协作以及沟通协调能力',
    //       '有商业设计经验，云计算、网络建站产品设计经验者优先',
    //       '有响应式设计经验者优先',
    //       '人要靠谱、踏实。'
    //     ]
    //   },
    //   tips: '注：简历发送时带个人作品。'
    // }
  ],
  contactMethods: [{ title: '投递邮箱', content: 'HAOWEIWEI958@pingan.com.cn' }]
}

export default recruitData
